import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';

export default class GalleryPromote extends React.Component {
    static propTypes = {
        inSelectMode: PropTypes.bool.isRequired,
        photo: PropTypes.shape({
            id: PropTypes.string.isRequired,
            promotable: PropTypes.shape({
                state: PropTypes.oneOf([
                    null,
                    'promoted',
                    'rejected'
                ]),
                controls: PropTypes.shape({
                    reject: PropTypes.shape({
                        trigger: PropTypes.func
                    }),
                    unreject: PropTypes.shape({
                        trigger: PropTypes.func
                    }),
                    promote: PropTypes.shape({
                        trigger: PropTypes.func
                    }),
                    demote: PropTypes.shape({
                        trigger: PropTypes.func
                    })
                })
            }).isRequired
        }).isRequired,
    };
    static defaultProps = {};

    getButton = config => {
        return (
            <Tooltip key={`${this.props.photo.id}-${config.className}`} title={config.tip} position="right">
                <div className={`promotable-button ${config.className}`} onClick={() => config.trigger ? config.trigger(this.props.photo) : () => true}>
                    <i className={`fa ${config.icon}`}></i>
                </div>
            </Tooltip>
        );
    }

    mapStateToButtons = () => {
        const { promotable } = this.props.photo;
        let output = [];

        switch (promotable.state) {
            case 'promoted':
                output.push(
                    this.getButton({
                        className: 'demote selected',
                        icon: 'fa-arrow-circle-up',
                        tip: 'Demote',
                        trigger: promotable.controls && promotable.controls.demote && promotable.controls.demote.trigger
                    }),
                    this.getButton({
                        className: 'reject',
                        icon: 'fa-minus-circle',
                        tip: 'Reject',
                        trigger: promotable.controls && promotable.controls.reject && promotable.controls.reject.trigger
                    })
                );
                break;
            case 'rejected':
                output.push(
                    this.getButton({
                        className: 'promote',
                        icon: 'fa-arrow-circle-up',
                        tip: 'Reject',
                        trigger: promotable.controls && promotable.controls.promote && promotable.controls.promote.trigger
                    }),
                    this.getButton({
                        className: 'unreject selected',
                        icon: 'fa-minus-circle',
                        tip: 'Unreject',
                        trigger: promotable.controls && promotable.controls.unreject && promotable.controls.unreject.trigger
                    })
                );
                break;
            default:
                output.push(
                    this.getButton({
                        className: 'promote',
                        icon: 'fa-arrow-circle-up',
                        tip: 'Promote',
                        trigger: promotable.controls && promotable.controls.promote && promotable.controls.promote.trigger
                    }),
                    this.getButton({
                        className: 'reject',
                        icon: 'fa-minus-circle',
                        tip: 'Reject',
                        trigger: promotable.controls && promotable.controls.reject && promotable.controls.reject.trigger
                    })
                );
        }

        return output;
    }

    render() {
        const { inSelectMode } = this.props;
        const { promotable } = this.props.photo;

        const buttons = this.mapStateToButtons();
        if (!buttons.length) {
            return (null);
        }

        return (
            <div className={`component-gallery-promote ${promotable.state || ''} ${promotable.state ? 'selected' : ''} ${inSelectMode ? 'select-mode' : ''}`}>
                {buttons}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryPromote/index.js